import React from 'react';
import Terminal from './components/Terminal';
import Instructions from './components/Instructions';
import TopNav from './components/TopNav';
import './App.css';
import Activity from './components/Activity';

const App: React.FC = () => {
  return (
    <div className="app-container">
      <TopNav />
      <div className="module-card terminal-card">
        <Terminal />
      </div>

      <div className="module-card instructions-card">
        <Instructions />
      </div>

      <div className="module-card staking-card">
        <Activity />
      </div>
    </div>
  );
};

export default App;
